import { render, staticRenderFns } from "./MailSignatureEditor.vue?vue&type=template&id=93d0787a"
import script from "./MailSignatureEditor.vue?vue&type=script&lang=js"
export * from "./MailSignatureEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports